import React from 'react';

function PaymentPage() {
    return (
        <>
        <section className="payment">
            <h1 className="payment__header">Payment Page</h1>
        </section>
        </>

    )
}

export default PaymentPage;